import React, { useEffect, useState } from 'react';
import Layout from '../Componets/Layout';
import { useNavigate } from 'react-router-dom';
import '../App.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import axios from 'axios';

export default function Home(p) {
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL; // Get the API URL from the .env file
  // States to manage the counters
  const [clientCount, setClientCount] = useState(0);
  const [adminCount, setAdminCount] = useState(0);
  const [dashboardCount, setDashboardCount] = useState(null); // Initialize as null

  // Function to handle counter animation
  const animateCounter = (target, setCount) => {
    let start = 0;
    const increment = target / 100; // Increment over 100 steps
    const interval = setInterval(() => {
      start += increment;
      if (start >= target) {
        clearInterval(interval);
        setCount(target); // Set final value
      } else {
        setCount(Math.ceil(start));
      }
    }, 10); // Interval speed
  };

  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role !== 'SUPER_ADMIN') {
      navigate('/');
    }
  }, [navigate]);

  useEffect(() => {
    if (!localStorage.getItem('alertShown')) {
      toast.success('Login successfully');
      localStorage.setItem('alertShown', 'true');
    }
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 600,
      easing: 'ease-in-out',
      once: true,
      mirror: false,
      devtool: false,
    });
    AOS.refresh();
  }, []);

  // Fetch data and animate counters
  useEffect(() => {
    const fetchRecords = async () => {
      const token = localStorage.getItem('token');
      try {
        const response = await axios.get(`${apiUrl}/api/dashboard/superadmin`, {
          headers: {
            Authorization: token,
          },
        });
        setDashboardCount(response.data); // Set dashboard data
      } catch (error) {
        console.error(error.response.data.message);
        error.response?.status === 401 && navigate('/');
      }
    };

    fetchRecords();
  }, [apiUrl]);

  // Animate counters after dashboardCount is set
  useEffect(() => {
    if (dashboardCount) {
      animateCounter(dashboardCount.Clintcount, setClientCount);
      animateCounter(dashboardCount.AdminCount, setAdminCount);
    }
  }, [dashboardCount]); // Depend on dashboardCount

  return (
    <Layout ac1="active">
      <main id="main" className="main">
        <div className="pagetitle mb-4">
          <h1>Dashboard</h1>
        </div>

        {/* ------------------------------------------Page Title ---------------------------- */}
        <section id="stats" className="stats section">
          <div className="container" data-aos="fade-up" data-aos-delay="100">
            <div className="row gy-4">
              <div
                className="col-lg-3 col-md-6 cursor-pointer"
                onClick={() => navigate('/ViewClient')}
              >
                <div className="stats-item d-flex align-items-center w-100 h-100">
                  <i className="bi bi-person-fill-gear color-blue flex-shrink-0"></i>
                  <div>
                    <span>{clientCount}</span>
                    <p>Manage Client</p>
                  </div>
                </div>
              </div>

              <div
                className="col-lg-3 col-md-6 cursor-pointer"
                onClick={() => navigate('/ViewAdmins')}
              >
                <div className="stats-item d-flex align-items-center w-100 h-100">
                  <i
                    className="bi bi-person-fill-add color-orange flex-shrink-0"
                    style={{ color: '#ee6c20' }}
                  ></i>
                  <div>
                    <span>{adminCount}</span>
                    <p>Manage Admin</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <ToastContainer />
      </main>
    </Layout>
  );
}
